// src/utils/musiqId.js
// ID court "MusIQ" : 20 caractères [0-9A-Z], déterministe à partir d'un UUID.
// Pas de BigInt ni crypto pour éviter les warnings lint/env.

const ALPHABET = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ';

export function toMusiqId(input) {
  const hex = String(input || '')
    .replace(/-/g, '')
    .toLowerCase();
  if (!hex) return random10();

  // Petit hash déterministe basé sur les nibbles, plié sur 20 cases en base36.
  const out = new Array(10).fill(0);
  for (let i = 0; i < hex.length; i++) {
    const nibble = parseInt(hex[i], 16);
    if (Number.isNaN(nibble)) continue;
    const idx = (i * 7 + nibble) % 10; // répartition
    out[idx] = (out[idx] * 13 + nibble + i) % 36;
  }
  return out.map((n) => ALPHABET[n]).join('');
}

function random10() {
  let s = '';
  for (let i = 0; i < 10; i++) {
    s += ALPHABET[Math.floor(Math.random() * 36)];
  }
  return s;
}

export function getDisplayMusiqId(p) {
  if (!p) return '';
  // Accepte une string (déjà un MusiqID) ou un objet patient
  if (typeof p === 'string') {
    const s = p.trim().toUpperCase();
    if (/^[0-9A-Z]{10}$/.test(s)) return s;
    if (/^[0-9a-f-]{32,36}$/i.test(s)) return toMusiqId(s);
    return s;
  }
  const fromField = p.musiq_id || p.musiqId || p.patient_uid || p.patientUid || p.uid || null;
  if (fromField) {
    const s = String(fromField).trim().toUpperCase();
    if (/^[0-9A-Z]{10}$/.test(s)) return s;
  }
  return toMusiqId(p?.id ?? '');
}
